module.exports = __webpack_public_path__ + "static/media/project2.4dd8a546.pdf";